import script from "./MiNTNews.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNews.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNews.vue?vue&type=style&index=0&id=d5051026&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5051026"]])

export default __exports__